import { config } from './config';

export async function trackAddToCart(productLink, productNumber, sessionId, customerId, website, userId) {
    const url = `${config.BASE_URL}/track/cart`;
    const userAgent = navigator.userAgent;
    
    const body = {
        p_n: productNumber || null,
        site: website || null,
        c_id: customerId || null,
        url: productLink || null,
        ua: userAgent || null,
        se_id: sessionId || null,
        u_id: userId || null
    }
    
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });
    
    return response;
}